import React from 'react';
import { BookOpen, FileText, Video, Download, ExternalLink } from 'lucide-react';
import { useTranslation } from 'react-i18next';

const ResourcesModal: React.FC = () => {
  const { t } = useTranslation();

  const resources = [
    {
      title: t('footer.modals.resources.items.cv_guide.title'),
      description: t('footer.modals.resources.items.cv_guide.description'),
      type: "PDF",
      icon: FileText,
      color: "from-blue-500 to-indigo-600"
    },
    {
      title: t('footer.modals.resources.items.templates.title'),
      description: t('footer.modals.resources.items.templates.description'),
      type: "Templates",
      icon: Download,
      color: "from-emerald-500 to-teal-600"
    },
    {
      title: t('footer.modals.resources.items.tutorials.title'),
      description: t('footer.modals.resources.items.tutorials.description'),
      type: t('footer.modals.resources.items.tutorials.type'),
      icon: Video,
      color: "from-purple-500 to-pink-600"
    },
    {
      title: t('footer.modals.resources.items.blog.title'),
      description: t('footer.modals.resources.items.blog.description'),
      type: t('footer.modals.resources.items.blog.type'),
      icon: ExternalLink,
      color: "from-orange-500 to-red-600"
    }
  ];

  return (
    <div className="text-slate-300 space-y-6">
      {/* Introduction */}
      <div className="text-center mb-8">
        <div className="w-20 h-20 mx-auto mb-6 bg-gradient-to-br from-blue-500 to-indigo-600 rounded-3xl flex items-center justify-center shadow-2xl">
          <BookOpen className="w-10 h-10 text-white" />
        </div>
        <p className="text-lg leading-relaxed">
          {t('footer.modals.resources.description')}
        </p>
      </div>

      {/* Resources */}
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        {resources.map((resource, index) => {
          const IconComponent = resource.icon;
          return (
            <div key={index} className="bg-slate-700/30 rounded-2xl p-6 hover:bg-slate-700/50 transition-all duration-300 cursor-pointer group">
              <div className="flex items-start">
                <div className={`w-12 h-12 bg-gradient-to-br ${resource.color} rounded-xl flex items-center justify-center mr-4 flex-shrink-0 group-hover:scale-110 transition-transform duration-300`}>
                  <IconComponent className="w-6 h-6 text-white" />
                </div>
                <div className="flex-1">
                  <div className="flex items-center justify-between mb-2">
                    <h3 className="text-lg font-semibold text-white group-hover:text-transparent group-hover:bg-gradient-to-r group-hover:from-indigo-400 group-hover:to-purple-400 group-hover:bg-clip-text transition-all duration-300">
                      {resource.title}
                    </h3>
                    <span className={`text-xs px-2 py-1 bg-gradient-to-r ${resource.color} text-white rounded-full`}>
                      {resource.type}
                    </span>
                  </div>
                  <p className="text-slate-400 text-sm leading-relaxed">
                    {resource.description}
                  </p>
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default ResourcesModal;
